import {createStyles} from '@material-ui/core';
import {defaultFont, greenColor, redColor} from '../../styles/style';

export const style = createStyles({
  mainContainer: {
    padding: '16px 24px',
    height: '100%',
    overflowY: 'auto',
  },
  mainContainer__row: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },

  mainContainer__infoGroup: {
    padding: '12px 16px 4px',
    marginTop: '16px',
  },
  infoGroup_hasNoThreats: {
    outline: `4px solid ${greenColor}`,
    outlineOffset: 0,
  },
  infoGroup_hasThreats: {
    outline: `4px solid ${redColor}`,
    outlineOffset: 0,
  },

  mainContainer__history: {
    ...defaultFont,
    padding: '16px',
    paddingBottom: '8px',
    marginTop: '16px',

    overflowY: 'auto',
    maxHeight: '280px',
  },
  history__title: {
    margin: 0,
    marginBottom: '8px',
    fontSize: '20px',
  },
  history__content: {
    padding: 0,
  },
  history__date: {
    flex: '1 !important',
    minWidth: '100px',
  },
  history__categories: {
    flex: '3 !important',
    minWidth: '100px',
  },

  mainContainer__last_reported: {
    margin: '10px 0 10px',
    fontSize: '16px',
    color: redColor,
  },

  singleElement: {
    ...defaultFont,
    marginBottom: '8px',
  },
  singleElement__header: {
    fontSize: '18px',
    paddingBottom: '4px',
    margin: 0,
  },
  singleElement__value: {
    fontSize: '16px',
    paddingTop: '4px',
    paddingLeft: '16px',
  },
});
